import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyService } from '../../configuration/company/company.service.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { ICreateSubRouteFunction } from './interfaces/create-sub-route-function.interface';
import SubRouteFunctionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route-function/sub-route-function.entity';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { SubRouteFunctionService } from './sub-route.service';
import { IUpdateSubRouteFunction } from './interfaces/update-sub-route-function.interface';
import { ReplaySubject, Subject, Subscription, take, takeUntil } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SubRouteModelEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/sub-route-model.enum';
import ReasonVisitAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-visits/reason-visits.entity';
import { ReasonVisitService } from '../../master/reason-for-visit/reason-for-visit.service';
import { AddSubRouteFunctionActivitie } from '../sub-route-function-activities/sub-route-function-acitivities.component';
import { SubRouteFunctionActivityService } from '../sub-route-function-activities/sub-route-function-activities.service';
import ShortSubRouteFunctionActivityAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route-function/sub-route-function-activity/sub-route-function-activity.entity';
import { DeleteConfirmationComponent } from '../../business-partners/business-partner/delete-modal/delete-modal.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { RoutesFiltersComponent } from '../../filters/routes-filters/routes-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: "app-subroute-function",
  standalone: true,
  templateUrl: "./sub-route-function.component.html",
  styleUrl: "./sub-route-function.component.scss",
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    HoverMenuDirective
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})
export class SubRouteFunctionComponent implements AfterViewInit, OnDestroy {
  displayedColumnsI: string[] = ["activity", "reason_visit", "status", "actions"];
  displayedColumns: string[] = ["name", "company", "statusId", "actions"];
  currentCreateSubRouteFunction: ICreateSubRouteFunction =
    this.initializeCreateSubRouteFunction();
  currentUpdateSubRouteFunction: SubRouteFunctionAttributes | undefined;

  companyList: CompanyAttributes[] = [];
  visitList: ReasonVisitAttributes[] = [];
  selectedCompanyIds: string[] = [];
  modelList: { key: SubRouteModelEnum; value: string }[] = [];

  dataSource: SubRouteFunctionAttributes[] = [];
  searchQuery = "";
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("addModalActivitie") addModalActivitie!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  protected _onDestroy = new Subject<void>();

  /** control for the selected companies for multi-selection */
  public companiesMultiCtrl: FormControl<CompanyAttributes[]> = new FormControl<
    CompanyAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public companiesMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of companies filtered by search keyword */
  public filteredCompanies: ReplaySubject<CompanyAttributes[]> =
    new ReplaySubject<CompanyAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredCompaniesCache: CompanyAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  /** control for the selected companies for multi-selection */
  public visitMultiCtrl: FormControl<ReasonVisitAttributes[]> = new FormControl<
    ReasonVisitAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public visitMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of companies filtered by search keyword */
  public filteredVisit: ReplaySubject<ReasonVisitAttributes[]> =
    new ReplaySubject<ReasonVisitAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredVisitCache: ReasonVisitAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateVisit = false;
  isCheckedVisit = false;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses : number []=[];
  form: FormGroup

  // Lazy loading flags
  loadFiltersData = false;
  companiesLoaded = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly subrouteFunctionService: SubRouteFunctionService,
    private readonly visitService: ReasonVisitService,
    private readonly activityService: SubRouteFunctionActivityService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
      this.form = this.fb.group({
      companyId: [],
      modelEnum: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  private initializeCreateSubRouteFunction(): ICreateSubRouteFunction {
    return {
      code: "",
      model: "",
      name: "",
      companiesIds: [],
      reasonVisitsIds: [],
      vehicleRequired: false,
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  private fetchReasonVisit(): void {
    this.visitService.findToComboBox().subscribe((res) => {
      this.visitList = res.data;
      this.filteredVisit.next(this.visitList);

      if (this.currentUpdateSubRouteFunction?.reasonVisits) {
        this.filteredVisit.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSubRouteFunction.reasonVisits
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.visitMultiCtrl.setValue(selectedMaterials);
        });
      }
      // listen for search field value changes
      this.visitMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterVisitMulti();
          this.setToggleAllCheckboxStateVisit();
        });
    });
  }

  protected filterVisitMulti() {
    if (!this.visitList) {
      return;
    }
    // get the search keyword
    let search = this.visitMultiFilterCtrl.value;
    if (!search) {
      this.filteredVisitCache = this.visitList;
      this.filteredVisit.next(this.visitList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredVisitCache = this.visitList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredVisit.next(this.filteredVisitCache);
  }

  toggleSelectAllVisit(selectAllValue: boolean) {
    this.filteredVisit
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.visitMultiCtrl.patchValue(val);
        } else {
          this.visitMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateVisit() {
    let filteredLength = 0;
    if (this.visitMultiCtrl && this.visitMultiCtrl.value) {
      this.filteredVisitCache.forEach((el) => {
        if (this.visitMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateVisit =
        filteredLength > 0 && filteredLength < this.filteredVisitCache.length;
      this.isCheckedVisit =
        filteredLength > 0 && filteredLength === this.filteredVisitCache.length;
    }
  }

   //Horarios de entrega
   openAddActivitieModal(subRoute: SubRouteFunctionAttributes): void {
      const dialogRef = this.dialog.open(AddSubRouteFunctionActivitie, {
        panelClass: ".form-modal-interlocutor",
        data: subRoute,
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          if (subRoute) {
            this.updateActivity(result);
          } else {
            this.createActivity(result);
          }
        }
      });
    }

    createActivity(result): void {
        this.activityService
          .createEmbedded(this.currentUpdateSubRouteFunction._id.toString(), result)
          .subscribe({
            next: () => {
              this.snackBar.open("Registro creado con éxito", "Cerrar", {
                duration: 5000,
                verticalPosition: "top",
              });
              this.activityService
                .findByFunctionId(this.currentUpdateSubRouteFunction._id.toString())
                .subscribe((data) => {
                  this.currentUpdateSubRouteFunction.activities = data?.data;
                });
            },
            error: (err) => {
              this.snackBar.open(
                err.error.message || "Error al crear el registro",
                "Cerrar",
                { duration: 5000, verticalPosition: "top" }
              );
            },
          });
    }
  
    updateActivity(result): void {
        this.activityService
          .updateEmbedded(
            this.currentUpdateSubRouteFunction._id.toString(),
            result._id.toString(),
            result
          )
          .subscribe({
            next: () => {
              this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
                duration: 5000,
                verticalPosition: "top",
              });
              this.activityService
                .findByFunctionId(this.currentUpdateSubRouteFunction._id.toString())
                .subscribe((data) => {
                  this.currentUpdateSubRouteFunction.activities = data?.data;
                });
            },
            error: (err) => {
              this.snackBar.open(
                err.error.message || "Error al actualizar el registro",
                "Cerrar",
                { duration: 5000, verticalPosition: "top" }
              );
            },
          });
    }


    onActivitieStatusChange(event: boolean, activity: ShortSubRouteFunctionActivityAttributes ): void {
        const originalStatusId = activity.statusId;
        const updatedStatusId = event ? 1 : 0;
        const updatedFrequency: any = {
          statusId: updatedStatusId,
        };
        this.activityService
          .updateEmbedded(
            this.currentUpdateSubRouteFunction._id.toString(),
            activity._id.toString(),
            updatedFrequency
          )
          .subscribe({
            next: () => {
              this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
                duration: 5000,
                verticalPosition: "top",
              });
              this.activityService
                .findByFunctionId(this.currentUpdateSubRouteFunction._id.toString())
                .subscribe((data) => {
                  this.currentUpdateSubRouteFunction.activities = data?.data;
                });
            },
            error: (err) => {
              activity.statusId = originalStatusId;
              this.snackBar.open(
                err.error.message || "Error al actualizar el registro",
                "Cerrar",
                { duration: 5000, verticalPosition: "top" }
              );
            },
          });
      }

      
        openDeleteActivity(item: any): void {
          this.dialog
            .open(DeleteConfirmationComponent, {
              data: item,
              panelClass: "delete-modal",
              disableClose: true,
            })
            .afterClosed()
            .subscribe((result) => result && this.deleteItineraryActivity(item));
        }
      
        deleteItineraryActivity(item: any): void {
          this.activityService
            .deleteEmbedded(
              this.currentUpdateSubRouteFunction._id.toString(),
              item._id.toString(),
              item
            )
            .subscribe(() => {
              this.snackBar.open("Actividad eliminada con éxito", "Cerrar", {
                duration: 5000,
                verticalPosition: "top",
              });
              this.activityService
                .findByFunctionId(this.currentUpdateSubRouteFunction._id.toString())
                .subscribe((data) => {
                  this.currentUpdateSubRouteFunction.activities = data?.data;
                });
            });
        }

     openActivitieModal(subroute: SubRouteFunctionAttributes): void {
        this.currentUpdateSubRouteFunction = {
          ...subroute,
        };
        this.dialog
          .open(this.addModalActivitie, { panelClass: "form-modal", disableClose: true })
          .afterClosed()
          .subscribe(() => {
          });
      }
  

  private fetchCompanies(): void {
    if (this.companiesLoaded) return;
    this.companiesLoaded = true;
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.filteredCompanies.next(this.companyList);

      this.filteredCompanies.pipe(take(1)).subscribe((materials) => {
        const selectedMaterials = materials.filter((material) =>
          this.currentUpdateSubRouteFunction?.companies
            .map((r) => r._id.toString())
            .includes(material._id.toString())
        );
        this.companiesMultiCtrl.setValue(selectedMaterials);
      });

      // listen for search field value changes
      this.companiesMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterDistribMulti();
          this.setToggleAllCheckboxStateDistrib();
        });
    });
  }

  protected filterDistribMulti() {
    if (!this.companyList) {
      return;
    }
    // get the search keyword
    let search = this.companiesMultiFilterCtrl.value;
    if (!search) {
      this.filteredCompaniesCache = this.companyList;
      this.filteredCompanies.next(this.companyList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredCompaniesCache = this.companyList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredCompanies.next(this.filteredCompaniesCache);
  }

  toggleSelectAllCompanies(selectAllValue: boolean) {
    this.filteredCompanies
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.companiesMultiCtrl.patchValue(val);
        } else {
          this.companiesMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateDistrib() {
    let filteredLength = 0;
    if (this.companiesMultiCtrl && this.companiesMultiCtrl.value) {
      this.filteredCompaniesCache.forEach((el) => {
        if (this.companiesMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredCompaniesCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredCompaniesCache.length;
    }
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    let filter: IFilters = {
      companyId: this.form.get("companyId").value,
      modelEnum: this.form.get("modelEnum").value,
      status: this.selectedStatuses

    }
    this.subrouteFunctionService
      .findAllWithCount(
        {
          currentPage: pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof SubRouteFunctionAttributes {
    const validSortFields: (keyof SubRouteFunctionAttributes)[] = [
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof SubRouteFunctionAttributes
    )
      ? (this.sort.active as keyof SubRouteFunctionAttributes)
      : "name";
  }

  private getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map(
      (id) =>
        this.companyList.find((company) => company._id.toString() === id)?.id
    );
  }

  onCompanySelectionChange(selectedIds: string[]): void {
    this.selectedCompanyIds = selectedIds;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }
   
  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: SubRouteFunctionAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.form.reset({
      companyId: null,
      modelEnum: null
    })
    this.findAllWithCount();
  }

  initializeComboBox() {
    this.fetchCompanies();
    this.fetchReasonVisit();
    this.modelList = Object.entries(SubRouteModelEnum).map(([key, value]) => ({
      key: key as SubRouteModelEnum, // Aseguramos el tipo correcto
      value,
    }));
  }

  openCreateModal(): void {
    this.currentUpdateSubRouteFunction = null;
    this.currentCreateSubRouteFunction =
      this.initializeCreateSubRouteFunction();
    this.initializeComboBox();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createSubRouteFunction());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(routeArea: SubRouteFunctionAttributes): void {
    this.initializeComboBox();
    this.currentUpdateSubRouteFunction = { ...routeArea };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) =>result && this.updateSubRouteFunction(routeArea._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  resetFormControls(): void {
    this.companiesMultiCtrl.reset();
    this.visitMultiCtrl.reset();
  }  

  createSubRouteFunction(): void {
    this.currentCreateSubRouteFunction.companiesIds =
      this.companiesMultiCtrl.value.map((ware: CompanyAttributes) =>
        ware._id.toString()
      );
    this.currentCreateSubRouteFunction.reasonVisitsIds =
      this.visitMultiCtrl.value?.map((ware: ReasonVisitAttributes) =>
        ware._id.toString()
      ) ?? [];
    this.subrouteFunctionService
      .create(this.currentCreateSubRouteFunction)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.resetFormControls();
          this.findAllWithCount();
          this.dialogRefAdd.close()
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateSubRouteFunction(id: string): void {
    if (this.currentUpdateSubRouteFunction) {
      const updatedSubRouteFunction: IUpdateSubRouteFunction = {
        ...this.currentUpdateSubRouteFunction,
        companiesIds: this.companiesMultiCtrl.value.map(
          (company: CompanyAttributes) => company._id.toString()
        ),
        reasonVisitsIds: this.visitMultiCtrl.value.map(
          (visit: ReasonVisitAttributes) => visit._id.toString()
        ),
      };

      this.subrouteFunctionService
        .update(id, updatedSubRouteFunction)
        .subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.resetFormControls();
            this.findAllWithCount();
            this.dialogRefEdit.close()
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
    }
  }

  onStatusChange(event: boolean, routeArea: SubRouteFunctionAttributes): void {
    const originalStatusId = routeArea.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedSubRouteFunction: IUpdateSubRouteFunction = {
      statusId: updatedStatusId,
    };

    this.subrouteFunctionService
      .update(routeArea._id.toString(), updatedSubRouteFunction)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          routeArea.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(routeArea: SubRouteFunctionAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: routeArea, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(routeArea._id.toString()));
  }

  delete(id: string): void {
    this.subrouteFunctionService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }
   
  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
